import { TextField, TextFieldProps } from '@mui/material';
import { Field, FieldProps } from 'formik';

export const CustomTextField = ({
  onChange,
  onBlur,
  fullWidth = true,
  variant = 'standard',
  ...propsRest
}: TextFieldProps) => {
  return (
    <Field name={propsRest.name}>
      {({ field, form: { touched, errors } }: FieldProps) => (
        <TextField
          {...propsRest}
          {...field}
          onChange={e => {
            field.onChange(e);
            if (onChange) onChange(e);
          }}
          onBlur={e => {
            field.onBlur(e);
            if (onBlur) onBlur(e);
          }}
          variant={variant}
          fullWidth={fullWidth}
          error={touched[field.name] && Boolean(errors[field.name])}
          helperText={touched[field.name] && errors[field.name]}
        />
      )}
    </Field>
  );
};
